import Swal from 'sweetalert2';
import { templateAddProjects } from '../loader-template';
import { getAxiosClient } from '~src/api';
import { isLoggedUserGlobalEditor } from '~src/user';

export const createNewProjectType = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const { value: name } = await Swal.fire({
    title: 'Come vuoi chiamare questo nuovo tipo di progetto?',
    input: 'text',
    inputAttributes: {
      autocapitalize: 'off',
    },
    inputValidator: (value) => {
      if (!value) {
        return 'Inserisci un nome';
      }
    },
    showCancelButton: true,
    showLoaderOnConfirm: true,
    reverseButtons: true,
    confirmButtonColor: '#278e8e',
    confirmButtonText: 'Avanti &rarr;',
    currentProgressStep: 0,
    progressSteps: ['1', '2'],
  });

  if (!name) {
    return;
  }

  const { value: funeralRelation } = await Swal.fire({
    title: 'Vuoi che questo progetto sia relativo ad un servizio funebre?',
    input: 'radio',
    inputValue: 1,
    inputPlaceholder:
      'Vuoi collegare questa nuova tipologia ad un servizio funebre?',
    inputOptions: {
      0: 'No',
      1: 'Si',
    },
    showCancelButton: true,
    showLoaderOnConfirm: true,
    reverseButtons: true,
    confirmButtonColor: '#278e8e',
    confirmButtonText: 'Salva',
    currentProgressStep: 1,
    progressSteps: ['1', '2'],
  });

  if (!funeralRelation) {
    return;
  }

  Swal.fire({
    title: 'Salvataggio in corso',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    willOpen: () => {
      Swal.showLoading();
    },
  });

  const httpClient = await getAxiosClient();

  const data = {
    name: name,
    isRelatedToFuneral: funeralRelation === '1' ? true : false,
    order: 100, // Scelto alto perche li gestiamo a mano
    multiplier: 1,
  };

  let tableName;

  const isGlobalEditor = await isLoggedUserGlobalEditor();

  if (isGlobalEditor) {
    data.isGlobal = true;
    tableName = 'editor_project_types_default';
  } else {
    tableName = 'editor_project_types';
  }

  try {
    const response = await httpClient.post(
      `${process.env.PARSE_API_URL}/${tableName}`,
      { data }
    );
    if (response.status !== 200) {
      return Swal.fire({
        icon: 'error',
        title: 'Qualcosa &egrave; andato storto',
        html: 'Il salvataggio &egrave; fallito. Si prega di riprovare',
        confirmButtonColor: '#278e8e',
      });
    } else {
      window.editorLoader.projects.items.push(response.data.data);

      await Swal.fire({
        icon: 'success',
        title: 'Tutto pronto!',
        text: 'Nuova tipologia di progetto salvata correttamente!',
        confirmButtonColor: '#278e8e',
      });
      templateAddProjects(true);
    }
  } catch (error) {
    return Swal.fire({
      icon: 'error',
      title: 'Qualcosa &egrave; andato storto',
      html: 'Il salvataggio &egrave; fallito. Si prega di riprovare',
      footer: `Errore: <strong>${error.message}</strong>`,
      confirmButtonColor: '#278e8e',
    });
  }
};
